<template>
  <div>
    <v-dialog v-model="contextDialog" max-width="600px">
      <v-card style="overflow: hidden">
        <v-card-text style="height: 305px">
          <v-row>
            <v-radio-group row v-model="extension">
              <v-radio label="PDF" value="PDF" />
              <v-radio label="CSV" value="CSV" />
              <v-radio label="HTML" value="HTML" />
              <v-radio label="XLS" value="XLS" />
              <v-radio label="XLSX" value="XLSX" />
            </v-radio-group>
          </v-row>
          <v-row>
            <template v-if="!$store.getters['Ajax/loading']">
              <v-col cols="6" class="report-flex">
                <div @click="downloadGroups" class="pa-4 text-md-center elevation-5 ma-3 report-buttons">
                  <div style="padding-left: 45px;">
                    <v-icon color="primary" style="font-size: 80px;">view_agenda</v-icon>
                    <v-btn x-small fab color="success" style="position: relative; right: 25px; top: 20px;">
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </div>
                  <h3>
                    {{ $t("global.downloadGroupsOnly") }}
                  </h3>
                </div>
              </v-col>
              <v-col cols="6" class="report-flex">
                <div @click="downloadDetailed" class="pa-4 text-md-center elevation-5 ma-3 report-buttons">
                  <div style="padding-left: 45px;">
                    <v-icon color="primary" style="font-size: 80px;">view_headline</v-icon>
                    <v-btn x-small color="success" fab style="position: relative; right: 25px; top: 20px;">
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </div>
                  <h3>
                    {{ $t("global.downloadDetailed") }}
                  </h3>
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="isSummary" :label="$t('booking.addSummaryRow')" />
              </v-col>
            </template>
            <v-col cols="12" style="text-align: center" v-if="$store.getters['Ajax/loading']">
              <v-progress-circular indeterminate color="primary" size="105" />
              <h3 class="mt-4">{{ $t("global.generating") }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="contextDialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import downloadFile from "../../../repository/downloadFile";

export default {
  name: "BookingReportDownloadComponent",
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    columns: {
      required: true
    },
    filters: {
      required: true
    },
    type: {
      required: true
    },
    options: {
      required: false,
      default: null
    }
  },
  data: () => ({
    extension: "CSV",
    isSummary: false
  }),
  computed: {
    contextDialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("update:dialog", val);
      }
    }
  },
  methods: {
    downloadGroups() {
      downloadFile("booking/report/download-report-as-file", "GET", {
        isDetailed: false,
        columns: this.columns,
        filters: this.filters,
        type: this.type,
        pagination: this.options,
        extension: this.extension,
        isSummary: this.isSummary
      });
    },
    downloadDetailed() {
      downloadFile("booking/report/download-report-as-file", "GET", {
        isDetailed: true,
        columns: this.columns,
        filters: this.filters,
        pagination: this.options,
        type: this.type,
        extension: this.extension,
        isSummary: this.isSummary
      });
    }
  }
};
</script>

<style scoped>
.report-buttons {
  background-color: rgb(245, 245, 245);
  width: 215px;
  height: 160px;
  display: inline-block;
}
.report-flex {
  text-align: center;
  min-width: 215px;
}
</style>
